import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildHeaderComponent } from './child-header.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  imports: [
    MatTooltipModule,
    CommonModule,
    FormsModule,
    NgbModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule, 
    MatButtonModule,
    MatSlideToggleModule,
  ],
  declarations: [ChildHeaderComponent],
  exports: [ ChildHeaderComponent ]
})
export class ChildHeaderModule { }
